import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import qs from 'qs';

export const trainingService = {
  getDashboardStats,
  getComplianceStats,
  getComplianceData,
  getSessionDetail,
  searchPeople,
  getUserPermissions,
  getPersonDetail,
};

function getDashboardStats(propertyId) {
  return axios
    .get(`${apiEndpoint.training}/dashboard-stats?property_id=${propertyId}`, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

function getComplianceStats(propertyId) {
  return axios
    .get(`${apiEndpoint.training}/compliance-stats?property_id=${propertyId}`, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

function getComplianceData(propertyId, params = {}) {
  const queryString = qs.stringify({ property_id: propertyId, ...params }, { addQueryPrefix: true });
  return axios
    .get(`${apiEndpoint.training}/compliance-data${queryString}`, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

function getSessionDetail(sessionId) {
  return axios
    .get(`${apiEndpoint.training}/session-detail?session_id=${sessionId}`, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

function getUserPermissions(propertyId) {
  return axios
    .get(`${apiEndpoint.training}/user-permissions?property_id=${propertyId}`, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return Promise.reject(new Error(res?.data?.message || 'Failed to fetch permissions'));
    })
    .catch(err => {
      console.error('getUserPermissions error:', err);
      return Promise.reject(err);
    });
}

function getPersonDetail(propertyId, personId, sourceType = 'user') {
  const queryString = qs.stringify({ property_id: propertyId, person_id: personId, source_type: sourceType }, { addQueryPrefix: true });
  return axios
    .get(`${apiEndpoint.training}/person-detail${queryString}`, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

function searchPeople(propertyId, query, limit = 20) {
  const queryString = qs.stringify({ property_id: propertyId, query, limit }, { addQueryPrefix: true });
  return axios
    .get(`${apiEndpoint.training}/search-people${queryString}`, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}
